import React, {
  useCallback,
  useMemo,
  useState,
} from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ScreenWidth } from 'appConstants';
import { useScreenWidth } from 'hooks';
import { SelectOption } from 'types';
import { profileSelectors } from 'store/profile/selectors';

import {
  Select,
  SelectTabs,
  TitleText,
} from 'components';

import { TabContentSeller } from './tabContentSeller';

import styles from './styles.module.scss';

const status = [
  {
    title: 'None',
    id: 1,
    name: 'None',
    sales: 2500,
    isNoStatus: true,
  },
  {
    title: 'seller',
    id: 2,
    name: 'seller',
    sales: 2500,
  },
  {
    title: 'advanced_seller',
    id: 3,
    name: 'advanced_seller',
    sales: 5000,
  },
  {
    title: 'premium_seller',
    id: 4,
    name: 'premium_seller',
    sales: 7500,
  },
  {
    title: 'top_seller',
    id: 5,
    name: 'top_seller',
    sales: 10000,
  },
];

export const StatusSellersContainer = () => {
  const isTablet = useScreenWidth(ScreenWidth.tablet);
  const { t } = useTranslation('status');
  const trans = useTranslation('main').t;
  const { rank } = useSelector(profileSelectors.getState);

  const [tab, setTab] = useState(0);

  const listStr = status.map((rankItem) => trans(`${rankItem.title}`));
  
  const listSelectOptions = useMemo(() => status.map(({ id, name }) => ({
    value: id,
    label: trans(name),
  })), [trans]);

  const myRankIndex = useMemo(() => status.findIndex(({ name }) => name === rank), [rank]);

  const onSelectTab = useCallback((n: number) => {
    if (n >= 0 && n < status.length) {
      setTab(n);
    }
  }, []);
  
  const onSelect = useCallback((value: SelectOption<number>) => {
    const newIndex = status.findIndex((item) => item.id === value.value);
    if (newIndex !== -1) {
      setTab(newIndex);
    }
  }, []);

  return (
    <div className={styles.status_container}>
      <div className={styles.status_top}>
        <TitleText
          text={t('Statuses_')}
          className={styles.status_top_title}
        />
        <div className={styles.status_top_info}>
          {isTablet ? (
            <Select
              options={listSelectOptions}
              onChange={onSelect}
              value={listSelectOptions[tab]}
            />
          ) : (
            <SelectTabs
              tabTitles={listStr}
              onSelect={onSelectTab}
              defaultActiveTab={myRankIndex}
            />
          )}
        </div>
      </div>
      <div className={styles.status_content}>
        <TabContentSeller data={status[tab]} />
      </div>
    </div>
  );
};
